import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';

import Utils from 'src/app/utils';

import timezones from 'timezones-list';

import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  account: any;
  alert_delays = Utils.getAlertDelayTimes();
  flex_alert_delays = Utils.getFlexAlertDelayTimes();
  flex_fall_alert_delays = Utils.getFlexFallAlertDelayTimes();
  //timezones = Utils.getTimezones();
  timezoneListArray = timezones;
  message_alert: any;
  day_hours = Utils.getDayHours();
  change_days = Utils.getChangeDays();
  auto_end_shift: any;
  auto_end_sms: any;
  status_reply: any;
  sms_reminder_alt: any;
  regionsArray = Utils.getArcRegions();
  // fa2_use_email: any;
  // fa2_use_sms: any;

  formGroup = new FormGroup({
    alert_delay: new FormControl('',[Validators.required]),
    timezone: new FormControl('', [Validators.required]),
    message_alert: new FormControl('',[]),
    auto_end_shift: new FormControl('',[]),
    auto_end_sms: new FormControl('',[]),
    assign_vehicle: new FormControl('',[]),
    status_reply: new FormControl('',[]),
    sms_reminder_alt: new FormControl('',[]),
    fa2: new FormControl('',[]),
    // fa2_use_email: new FormControl(false,[]),
    // fa2_use_sms: new FormControl(false,[]),
    alert_delay_highrisk: new FormControl('',[]),
    alert_delay_mandown: new FormControl('',[]),
    alert_delay_fall: new FormControl('',[]),
    password_change_on: new FormControl('',[]),
    password_change_days: new FormControl('',[]),
    arc_region: new FormControl('',[]),
    app_mfa: new FormControl('',[]),

  });

  noticesGroup:any;

  twoWayAudioGroup:any;

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  notices_contact:any;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) {



  }

  ngOnInit(): void {

    this.getAccount();

  }

  ngAfterViewInit()	: void {
    Utils.setupPopover();
  }

  getAccount(){

    this.okService.get("account",[])
    .subscribe((data) => {

      this.account = data.body;

      if(this.account.alert_delay == 3){
        this.alert_delays.unshift({"value":3,"name":"3 mins"});
      }

      if(this.account.arc_on){
        this.flex_alert_delays = Utils.getSMCFlexAlertDelayTimes();
      }

      //console.log("account",this.account);

      this.notices_contact = this.okService.billing.plan.comms_active ? [{'name':'Email'},{'name':'Sms'}] : [{'name':'Email'}];
      this.setForm();

    })
  }

  setForm(){

    this.formGroup.setValue({
      alert_delay: this.account.alert_delay,
      timezone: this.account.timezone,
      message_alert: this.account.message_alert,
      auto_end_shift: this.account.auto_end_shift,
      auto_end_sms: this.account.auto_end_sms,
      assign_vehicle: this.account.assign_vehicle,
      status_reply: this.account.status_reply,
      sms_reminder_alt: this.account.sms_reminder_alt,
      fa2: this.account.fa2,
      // fa2_use_email: _.includes(this.account.fa2_contact,"Email"),
      // fa2_use_sms: _.includes(this.account.fa2_contact,"SMS"),
      alert_delay_highrisk: this.account.alert_delay_highrisk,
      alert_delay_mandown: this.account.alert_delay_mandown,
      alert_delay_fall: this.account.alert_delay_fall,
      password_change_on: this.account.password_change_on,
      password_change_days: this.account.password_change_days,
      arc_region: this.account.arc_region,
      app_mfa: this.account.app_mfa,
    });

    if(!this.okService.isFromAdmin() && !this.okService.isSuperAdmin() && this.okService.settings.arc_on){
      this.formGroup.controls['alert_delay'].disable();
    }

    if(!this.okService.isFromAdmin() && !this.okService.isSuperAdmin()){
      this.formGroup.controls['sms_reminder_alt'].disable();
    }

    this.noticesGroup = new FormGroup({
      notices_on: new FormControl(this.account.notices_on,[Validators.required]),
      notices_contact: new FormControl(this.account.notices_contact),

      start_shift: new FormControl(this.account.notices_list['start_shift']),
      end_shift: new FormControl(this.account.notices_list['end_shift']),
      // check_in: new FormControl(this.account.notices_list['check_in']),
      // overdue: new FormControl(this.account.notices_list['overdue']),
      set_high_risk: new FormControl(this.account.notices_list['set_high_risk']),
      change_man_down: new FormControl(this.account.notices_list['change_man_down']),
      // alert_accepted: new FormControl(this.account.notices_list['alert_accepted']),
      // alert_acknowledged: new FormControl(this.account.notices_list['alert_acknowledged']),
      // alert_resolved: new FormControl(this.account.notices_list['alert_resolved']),

    });

    // If they are using SMC then we can have the SMC option available
    this.twoWayAudioGroup = new FormGroup({
      two_way_audio_enabled: new FormControl(this.account.two_way_audio_enabled),
      two_way_audio_number: new FormControl(this.account.two_way_audio_number),
      two_way_audio_on_fall: new FormControl(this.account.two_way_audio_on_fall),
      two_way_audio_smc: new FormControl(this.account.two_way_audio_smc),
    });

    if(!this.okService.isFromAdmin() && !this.okService.isSuperAdmin()){
      this.twoWayAudioGroup.controls['two_way_audio_enabled'].disable();
      this.twoWayAudioGroup.controls['two_way_audio_number'].disable();
      this.twoWayAudioGroup.controls['two_way_audio_on_fall'].disable();
      this.twoWayAudioGroup.controls['two_way_audio_smc'].disable();
    }


  }

  submitForm(){

    this.submitted = true;
    if (
      this.formGroup.valid
      ) {
        let values = this.formGroup.value

        this.okService.put("account",values)
        .subscribe((data) => {

          this.account = data.body;

          this.setForm();

          this.okService.setAlert(this.transloco.translate("Your settings have been updated"),"success");

        });

      }

    return false;
  }

  submitTwoWayAudioForm(){

    console.log(this.twoWayAudioGroup.value);

    this.submitted = true;
    if (
      this.twoWayAudioGroup.valid
      ) {
        let values = this.twoWayAudioGroup.value;

        this.okService.put("account",values)
        .subscribe((data) => {

          console.log(data.body);

          this.account = data.body;

          this.setForm();

          this.okService.setAlert(this.transloco.translate("Your settings have been updated"),"success");

        });

      }

    return false;

  }

  submitNoticesForm(){

    let values:any = {}

    values.notices_on = this.noticesGroup.value.notices_on;
    values.notices_contact = this.noticesGroup.value.notices_contact;
    values.notices_list = {};
    values.notices_list.start_shift = this.noticesGroup.value.start_shift;
    values.notices_list.end_shift = this.noticesGroup.value.end_shift;
    // values.notices_list.check_in = this.noticesGroup.value.check_in;
    // values.notices_list.overdue = this.noticesGroup.value.overdue;
    values.notices_list.set_high_risk = this.noticesGroup.value.set_high_risk;
    values.notices_list.change_man_down = this.noticesGroup.value.change_man_down;
    values.notices_list.alert_accepted = this.noticesGroup.value.alert_accepted;
    values.notices_list.alert_acknowledged = this.noticesGroup.value.alert_acknowledged;
    values.notices_list.alert_resolved = this.noticesGroup.value.alert_resolved;


    //console.log(values);

    this.okService.put("account/notices",values)
    .subscribe((data) => {

      this.account = data.body;

      //console.log("account",this.account);

      this.setForm();

      this.okService.setAlert(this.transloco.translate("Your Action Notice settings have been updated"),"success");

    });
  }

}
